import { useCallback, useState, type DetailedHTMLProps, type ImgHTMLAttributes } from 'react';

type Props = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  fallback?: string;
};

const Image = (props: Props) => {
  const [src, setSrc] = useState(props.src);
  const onError = useCallback(() => {
    setSrc(props.fallback);
  }, [props.fallback]);
  return <img {...props} src={src} onError={onError} />;
};

export default Image;
